import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import AttendanceBookComponent from "./Component/AttendanceBookComponent";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { toast } from "react-toastify";
import moment from "moment";

const AttendanceBookRujul = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(updateNavbarHeading("Attendance Book"));
  }, []);

  const UserContactID = JSON.parse(
    localStorage.getItem("user")
  )?.DefaultContactID;

  const intialFilterData = [
    { label: "Branch", value: 2 },
    { label: "HR Executive", value: UserContactID },
  ];
  const [attendanceBookData, setAttendanceBookData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [branchOption, setBranchOption] = useState([]);
  const [hrExecutiveOption, setHRExecutiveOption] = useState([]);
  const [calendarMonthOption, setCalendarMonthOption] = useState([]);
  const [shiftOption, setShiftOption] = useState([]);
  const [employeeOption, setEmplooyeeOption] = useState([]);
  const [attendanceStatusOption, setAttendanceStatusOPtion] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterFormData, setFilterData] = useState(intialFilterData);

  const [apiStatus, SetApiStatus] = useState(undefined);
  const [attendanceBookHeaderData, setAttendanceBookHeaderData] = useState([]);

  const calendarMonthData = filterFormData.find(
    (o) => o.label === "Calendar Month"
  );
  const selectedMonth = calendarMonthOption?.find(
    (ele) => ele?.value === calendarMonthData?.value
  ) || {
    totalDays: 31,
    ShortMonth: "Day",
  };
  const columns = {
    tmpEmployeeName: {
      text: "Employee",
      align: "start",
      visible: true,
      width: "150px",
    },
  };

  const finalColumns = {
    ...columns, // Ensure existing columns are preserved
    ...Array.from({ length: selectedMonth.totalDays }, (_, i) => ({
      [`Day${i + 1}`]: {
        text: `${i + 1} ${selectedMonth.ShortMonth}`,
        align: "center",
        visible: true,
        width: "80px",
        type: "Select",
        option: attendanceStatusOption || [],
      },
    })).reduce((acc, cur) => ({ ...acc, ...cur }), {}), // Merge day columns correctly
  };

  useEffect(() => {
    fetchGetDetails();
  }, []);
  const fetchGetDetails = async () => {
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/attendance-book/add-page/details`
      );

      SetApiStatus(response?.status);
      if (response?.status == 200) {
        const cleanedData = response?.data;

        const branchOpt = cleanedData?.branches?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setBranchOption(branchOpt);
        const attendanceStatusOpt = cleanedData?.attendanceStatus?.map(
          (ele) => ({
            value: ele?.value,
            label: ele?.text,
            color: ele?.color,
          })
        );
        setAttendanceStatusOPtion(attendanceStatusOpt);
        const monthOpt = cleanedData?.calendermonth?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
          totalDays: ele?.totalDays,
          ShortMonth: ele?.ShortMonth,
        }));
        setCalendarMonthOption(monthOpt);
        const employeeOpt = cleanedData?.employeelist?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setEmplooyeeOption(employeeOpt);
        const shiftOpt = cleanedData?.shift?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setShiftOption(shiftOpt);
        const executivesOpt = cleanedData?.executives?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setHRExecutiveOption(executivesOpt);
      }
    } catch (error) {
      console.error("Error while submitting data:", error);
      if (error.response && error.response.data && error.response.data.error) {
        toast.error(error.response.data.error, {
          position: "top-right",
        });
        console.error("Server responded with status:", error.response.status);
        console.error("Response data:", error.response.data);
      }
    }
  };

  const formDatas = [
    {
      name: "Branch",
      type: "Select",
      options: [...branchOption],
    },
    {
      name: "Calendar Month",
      type: "Select",
      options: [...calendarMonthOption],
    },
    {
      name: "Employee",
      type: "Select",
      options: [...employeeOption],
    },
    {
      name: "HR Executive",
      type: "Select",
      visible: true,
      options: [...hrExecutiveOption],
    },
    {
      name: "Shift",
      type: "Select",
      options: [...shiftOption],
    },
    {
      name: "Status Confirmed",
      type: "Checkbox",
      // options: [...shiftOption],
    },
    {
      name: "Current Month Joiners",
      type: "Checkbox",
    },
    {
      name: "Current Month Exits",
      type: "Checkbox",
    },
  ];

  const filteredBranchValue =
    filterFormData.find((o) => o.label === "Branch")?.value || 0;
  const filteredCalendarMonthValue =
    filterFormData.find((o) => o.label === "Calendar Month")?.value || 0;
  const filteredEmployeeValue =
    filterFormData.find((o) => o.label === "Employee")?.value || 0;
  const filteredHRExecutiveValue =
    filterFormData.find((o) => o.label === "HR Executive")?.value || 0;
  const filteredShiftValue =
    filterFormData.find((o) => o.label === "Shift")?.value || 0;
  const filteredStatusConfirmedValue =
    filterFormData.find((o) => o.label === "Status Confirmed")?.value || 0;
  const filteredCurrMonJoinersValue =
    filterFormData.find((o) => o.label === "Current Month Joiners")?.value || false;
  const filteredCurrMonRelValue =
    filterFormData.find((o) => o.label === "Current Month Exits")?.value || false;
    

  const handleGetData = async (e) => {
    e?.preventDefault();
    e?.stopPropagation();

    // Get all filter values at once
    const getFilterValue = (label) =>
      filterFormData.find((o) => o.label === label)?.value;

    const calendarMonth = getFilterValue("Calendar Month");
    if (!calendarMonth) {
      toast.error("Please select Calendar Month");
      return;
    }
    SetApiStatus(undefined);
    try {
      // Use URLSearchParams for safer URL construction
      const params = new URLSearchParams();
      params.append("P_ShiftID", getFilterValue("Shift") || 0);
      params.append("P_MonthID", calendarMonth);
      params.append("P_EmployeeID", getFilterValue("Employee") || "");
      params.append(
        "P_Status",
        getFilterValue("Status Confirmed") === true ? 1 : 0
      );
      // Add Current Month Joiners parameter
      params.append(
        "P_NewJoiner",
        getFilterValue("Current Month Joiners") === true ? 1 : 0
      );
      params.append(
        "P_Exits",
        getFilterValue("Current Month Exits") === true ? 1 : 0
      );

      const apiUrl = `${API_URL}rujul/attendance-book?${params.toString()}`;
      const response = await GetServiceCaller(apiUrl);

      SetApiStatus(response?.status);
      if (response.status === 200) {
        const cleanedData = response?.data || {};
        setAttendanceBookHeaderData(cleanedData.attendanceBook || []);
        setAttendanceBookData(cleanedData.attendancedata || []);
      } else {
        console.error("API Error Status:", response.status);
        toast.error("Failed to fetch attendance data");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e, name) => {
    // Handle both direct values and React Select objects
    const value = e?.value !== undefined ? e.value : e;

    setFilterData((prevFormData) => {
      // Remove existing entry if exists
      const filteredData = prevFormData.filter((item) => item.label !== name);

      // Add new entry
      return [...filteredData, { label: name, value }];
    });
  };
  const [newSelectedStatus, setNewSelectedStatus] = useState("");
  const [selectedItem, setSelectedItem] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedItems, setSelectedItems] = useState({});
  const [selectedResources, setSelectedResources] = useState([]);

  const handleColumnSelect = (selectedOption, item, columnName) => {
    setAttendanceBookData((prevData) =>
      prevData.map((row) =>
        row.LineNo === item.LineNo
          ? { ...row, [columnName]: Number(selectedOption.value).toFixed(4) }
          : row
      )
    );

    setSelectedItem(item);
    setNewSelectedStatus(Number(selectedOption.value).toFixed(4));

    setSelectedResources((prevResources) =>
      prevResources.map((resource) =>
        resource.LineNo === item.LineNo
          ? {
            ...resource,
            [columnName]: Number(selectedOption.value).toFixed(4),
          }
          : resource
      )
    );
  };

  const handleSelectAllChange = (event) => {
    const checked = event.target.checked;
    setSelectAllChecked(checked);
    const newSelectedItems = {};
    const newSelectedResources = checked ? [...attendanceBookData] : [];

    if (checked) {
      attendanceBookData.forEach((item) => {
        newSelectedItems[item.LineNo] = true;
      });
    }

    setSelectedItems(newSelectedItems);
    setSelectedResources(newSelectedResources);
  };

  const handleCheckboxChange = (e, id, item) => {
    const isChecked = e.target.checked;
    setSelectedItems((prevSelectedItems) => {
      const updatedSelectedItems = {
        ...prevSelectedItems,
        [id]: isChecked,
      };

      const allSelected =
        Object.keys(updatedSelectedItems).length ===
        attendanceBookData.length &&
        Object.values(updatedSelectedItems).every(Boolean);
      setSelectAllChecked(allSelected);

      return updatedSelectedItems;
    });

    setSelectedResources((prevSelectedResources) => {
      if (isChecked) {
        return [...prevSelectedResources, item];
      } else {
        return prevSelectedResources.filter(
          (resource) => resource.LineNo !== item.LineNo
        );
      }
    });
  };
  const [submitButtonStatus, setSubmitButtonStatus] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitButtonStatus(true);

    // Check if selectedResources is empty, null, or undefined
    if (!selectedResources || selectedResources.length === 0) {
      toast.error("Select at least one record", {
        position: "top-right",
      });
      return; // Stop execution if validation fails
    }

    try {
      // Get Current Month Joiners value
      const getFilterValue = (label) =>
        filterFormData.find((o) => o.label === label)?.value;

      // Call the API to submit data
      const response = await PostServiceCaller(
        `${API_URL}rujul/attendance-book`,
        {
          AttendanceBook: {
            MonthID: calendarMonthData?.value,
            RevisionNumber: attendanceBookHeaderData?.RevisionNumber,
            BranchID: filteredBranchValue,
            ExecutiveID: filteredHRExecutiveValue,
            ShiftID: filteredShiftValue,
            EmployeeID: filteredEmployeeValue,
            AttendanceStatus: getFilterValue("Status Confirmed") === true ? 1 : 0,
            NewJoiners: getFilterValue("Current Month Joiners") === true ? 1 : 0,
            Exits: getFilterValue("Current Month Exits") === true ? 1 : 0,
            TXNDate: moment(new Date()).format("DD-MM-YYYY"),
          },
          AttendanceBookLines: selectedResources,
        },
        "post"
      );

      if (response.status === 200) {
        setSubmitButtonStatus(false);
        toast.success("Data submitted successfully");
        window.location.reload();
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
        console.error("Response data:", response.data);
      }
    } catch (error) {
      if (error.name === "ValidationError") {
        console.error("Validation Error:", error);

        // Map validation errors to fields
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
      } else {
        console.error("Unexpected Error:", error);
      }
    }
  };





 const handleReset = async () => {
    setFilterData(intialFilterData);
    SetApiStatus(undefined);
    setLoading(true); // Start loading before API call

    try {
      // Reset API call should include all parameters including new ones
      const apiUrl = `${API_URL}rujul/attendance-book?P_ShiftID=&P_MonthID=&P_EmployeeID=&P_Status=&P_NewJoiner=&P_Exits=`;
      const response = await GetServiceCaller(apiUrl);

      SetApiStatus(response?.status);

      if (response?.status === 200) {
        const data = response?.data || {};
        setAttendanceBookHeaderData(data.attendanceBook || []);
        setAttendanceBookData(data.attendancedata || []);
      } else {
        console.error("API Error Status:", response?.status);
        toast.error("Failed to fetch attendance data");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Error fetching data");
    } finally {
      setLoading(false); // Stop loading regardless of outcome
    }
  };

  return (
    <div className="container-fluid" id="skill_section">
      <div className=" rounded bg-white" id="skill-table-area">
        <div className="row mt-2">
          <AttendanceBookComponent
            data={attendanceBookData}
            isSubmitStatus={submitButtonStatus}

            columns={finalColumns}
            itemsPerPage={8}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            showIcon1={true}
            showIcon2={false}
            showIcon3={false}
            showIcon4={false}
            isApiStatus={apiStatus}
            handleReset={handleReset}
            isRequiredStatus={true}
            showIcon5={false}
            formDatas={formDatas}
            filterFormData={filterFormData}
            handleGetData={handleGetData}
            isActionRequired={true}
            isAddNewBtnRequired={true}
            handleAddNew={handleSubmit}
            isFilterRequired={true}
            isCheckBoxRequired={true}
            handleColumnSelect={handleColumnSelect}
            selectedResource={selectedResources}
            selectAllChecked={selectAllChecked}
            handleCheckboxChange={handleCheckboxChange}
            handleSelectAllChange={handleSelectAllChange}
            // handleIcon1={handleEdit}
            // handleIcon4={handleOpen}
            handleChange={handleChange}
            add
            more
            function
            icons={{
              Icon1: <i class="bi bi-x-lg icons"></i>,
              Icon2: <i class="bi bi-trash-fill icons"></i>,
              Icon3: <i class="bi bi-eye-fill icons"></i>,
              Icon4: <i class="bi bi-person-plus icons"></i>,
              Icon4Text: "Create Employee",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AttendanceBookRujul;
